export default "__VITE_ASSET__DwHXuahF__"